import React from 'react';

import { ColumnLayout, Wrapper, Container } from 'components/Layout';

const Favorites: React.FC = () => {
  return (
    <ColumnLayout>
      <Wrapper>
        <Container>
          <h1>Favorites Screen</h1>
        </Container>
      </Wrapper>
    </ColumnLayout>
  );
};

export default Favorites;
